/* (c) hop.t@turing.com
Our simple redux-logic alike middleware (not redux-saga, it handle too much things)
/* Usage: fetchInfo

  fetchType: {
    type: The action type we want to fetch data from API
    successType: The action type we want to dispatch incase of success (optional)
    errorType: The action type we want to dispatch incase of error (optional)
  }

  fetchFunction: The services api function we want to call (use incase we need to do extra processing instead of just a POST) (optional)
  If fetchFunction undefined, the default POST function will be executed
}
*/
import { types } from './types';
import { post } from '../services';
import _ from 'lodash';
import { get } from '../utilities/tips';
import allSettled from 'promise.allsettled';

/* allSettled polyfill */
allSettled.shim();

/* ADD DEFAULT SUCCESS/ERROR SUFFIX SO WE DON'T HAVE TO WRITE THESE BY DEFAULT */
const DEFAULT_SUCCESS_SUFFIX = '_SUCCESS';
const DEFAULT_ERROR_SUFFIX = '_ERROR';

const fetchList = [];
const registerFetch = (fetchInfo) => {
  /* ALSO PREVENT THE SAME FETCH TYPE MULTIPLE ADDED */
  const index = _.findIndex(fetchList, (f) => f.fetchType.type === fetchInfo.fetchType.type);
  if (index !== -1) return;

  fetchList.push(fetchInfo);
};

const unregisterFetch = (type) => {
  _.remove(fetchList, function (f) {
    return f.fetchType.type === type;
  });
};

const cleanupFetches = () => {
  fetchList.length = 0;
};

const useMiddleware = dispatch => action => {
  dispatch(action);

  const matches = fetchList.filter(f => f.fetchType.type === action.type);
  if (!matches || matches.length === 0) {
    return;
  }

  /* REQUESTING INDICATOR */
  dispatch({ type: types.REQUESTING, requesting: true });

  const requests = [];
  matches.map(f => {
    if (f.fetchFunction) requests.push(f.fetchFunction(f, action));
    else requests.push(post(f, action));
  });

  Promise.allSettled(requests).then(allResults => {
    allResults.map((result, index) => {
      const fetchInfo = matches[index];
      if (result.status === 'fulfilled') {
        const successType = fetchInfo.fetchType.successType || `${action.type}${DEFAULT_SUCCESS_SUFFIX}`;
        const data = get(['value', 'data', 'result'], result);
        const { k, v, count } = result.value.data;
        dispatch({ type: successType, result: data, k, v, count });
      } else {
        const errorType = fetchInfo.fetchType.errorType || `${action.type}${DEFAULT_ERROR_SUFFIX}`;
        const data = get(['reason', 'response', 'data', 'result'], result);
        dispatch({ type: errorType, result: data });
      }
    });

    /* REQUESTING INDICATOR */
    dispatch({ type: types.REQUESTING, requesting: false });
  });
};

export { useMiddleware, registerFetch, unregisterFetch, cleanupFetches };
